module.exports = __webpack_public_path__ + "img/arcade (1).968e08b7.jpg";